var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticStyle: { padding: "20px", "background-color": "#fff" } },
    [
      _c(
        "el-col",
        {
          staticStyle: { display: "flex", "flex-direction": "column" },
          attrs: { span: 24 }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { staticClass: "agent-question-wrapper", attrs: { span: 24 } },
                [
                  _c("span", { staticClass: "agent-question-style" }, [
                    _vm._v("Are you an agent ? ")
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-start",
                    padding: "10px 10px"
                  },
                  attrs: { span: 24 }
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "agent-sign-in-btn",
                      attrs: { type: "primary" },
                      on: { click: _vm.requestAgentKit }
                    },
                    [_vm._v("Request Agent Kit")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-start",
                    padding: "10px 10px"
                  },
                  attrs: { span: 24 }
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "agent-sign-in-btn",
                      attrs: { type: "primary" },
                      on: { click: _vm.redirectToAgentLogin }
                    },
                    [_vm._v("Agent Sign in")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.requestAgentDialogVisible
        ? _c("request-agent-kit-dialog", {
            attrs: {
              "request-agent-dialog-visible": _vm.requestAgentDialogVisible
            },
            on: {
              onClose: function($event) {
                _vm.requestAgentDialogVisible = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c59c4e92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c59c4e92","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/agentSignInSection.vue
// module id = null
// module chunks = 